export default __webpack_public_path__ + "f6b61f5bd0cd57484292161767e6756d.png";